import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

const CustomSelect = ({ value, placeholder, options, onChange }) => {
  const [open, setOpen] = useState(false);

  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (selectRef.current && !selectRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={selectRef}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex h-11 w-full items-center justify-between rounded-md border border-[#14708A] bg-[#151515] px-4 text-left text-sm text-neutral-100 outline-none"
      >
        <span className={value ? "text-neutral-100" : "text-neutral-100/50"}>
          {value || placeholder}
        </span>

        <ChevronDown className="h-5 w-5 text-[#67D8FF]" />
      </button>

      {open && (
        <div className="absolute z-30 mt-1 w-full overflow-hidden rounded-md border border-[#14708A] bg-brand-100 shadow-lg">
          {options.map((option) => (
            <button
              key={option}
              type="button"
              onClick={() => {
                onChange(option);
                setOpen(false);
              }}
              className="block w-full px-4 py-3 text-left text-sm text-neutral-100 hover:bg-brand-19"
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
